import { convertJSONToArray, createElement, select } from "@utils/function";

export default function SetPopupContent() {
  if (!HQ.Properties.places) return;

  HQ.Properties.places.map((element) => {
    const { id, parent_id, icon } = element;

    // if parent_id is null and icon is not tennis court then return
    if (icon === "icon-tennis-court") {
      // if parent_id is null then return
      if (!parent_id) return;

      const scheduleElement = HQ.Properties.schedule[id];
      if (!scheduleElement) return;

      createContentForTennisPopup(id, scheduleElement);
    }
  });
}

function createContentForTennisPopup(idCourt, curentSchedule) {
  // loop for in key and value

  const tennisWrapper = createElement("div");
  tennisWrapper.classList.add("tennis");

  const marker = window[`marker-${idCourt}`];
  const getContent = marker.getPopup().getContent();

  const templateTennis = select(`.template-tennis-popup-share-${idCourt}`);

  if (!templateTennis) {
    const template = createElement("template");
    template.classList.add(`template-tennis-popup-share-${idCourt}`);

    template.innerHTML = getContent;

    // add template to body bottom
    document.body.appendChild(template);
  }

  // get template
  const template = select(`.template-tennis-popup-share-${idCourt}`);

  tennisWrapper.innerHTML = template.innerHTML;

  // --------------------------------------------------

  const elementsObj = convertJSONToArray(curentSchedule)
    .map((item, index) => {
      return updateContent(idCourt, item);
    })
    .join("");

  const tennisResults = createElement("div");
  tennisResults.classList.add("tennis-results");

  tennisResults.insertAdjacentHTML("beforeend", elementsObj);

  tennisWrapper.appendChild(tennisResults);

  marker.setPopupContent(tennisWrapper);
}

function updateContent(idCourt, item) {
  let checkLive = false;

  const player = JSON.parse(item.Player);
  const partner = JSON.parse(item.Partner);
  const oponent = JSON.parse(item.Opponent);
  const oponentPartner = JSON.parse(item.OpponentPartner);

  let playerRow = "";
  if (player) {
    playerRow = rowPlayerName(player);
  }

  let partnerRow = "";
  if (partner) {
    partnerRow = rowPlayerName(partner);
  }

  let oponentRow = "";
  if (oponent) {
    oponentRow = rowPlayerName(oponent);
  }

  let oponentPartnerRow = "";
  if (oponentPartner) {
    oponentPartnerRow = rowPlayerName(oponentPartner);
  }

  const playerCF = player?.Country ? player.Country : "";
  const partnerCF = partner?.Country ? partner.Country : "";
  const opponentCF = oponent?.Country ? oponent.Country : "";
  const opponentParnerCF = oponentPartner?.Country
    ? oponentPartner.Country
    : "";

  let vsDelimiter = player ? "vs" : "n/a";

  let rowInformation = `
    <table class="table-fix">
      <tr>
        <td class="tennis-player col-5">
          ${playerRow ? flagWithName(playerRow, playerCF) : ""}
          ${partnerRow ? flagWithName(partnerRow, partnerCF) : ""}
        </td>
        <td class="live-divider col-1">${vsDelimiter}</td>
        <td class="tennis-player col-5">
          ${oponentRow ? flagWithName(oponentRow, opponentCF) : ""}
          ${
            oponentPartnerRow
              ? flagWithName(oponentPartnerRow, opponentParnerCF)
              : ""
          }
        </td>
      </tr>
    </table>
  `;

  if (item.type === "LIVEDATA" && !checkLive) {
    const { PlayerTeam, OpponentTeam } = item.live;

    const livePlayerTeam = JSON.parse(PlayerTeam);
    const liveOpponentTeam = JSON.parse(OpponentTeam);

    const livePLayerTeamGameScore = livePlayerTeam.GameScore;
    const liveOpponentTeamGameScore = liveOpponentTeam.GameScore;

    const livePLayerTeamSetScores = livePlayerTeam.SetScores;
    const liveOpponentTeamSetScores = liveOpponentTeam.SetScores;

    const playerRow = livePlayerTeam.Player;
    const partnerRow = livePlayerTeam.Partner;
    const opponentRow = liveOpponentTeam.Player;
    const opponentPartnerRow = liveOpponentTeam.Partner;

    const playerCountry = playerCountryInfo(playerRow);
    const partnerCountry = playerCountryInfo(partnerRow);
    const opponentCountry = playerCountryInfo(opponentRow);
    const opponentParnerCountry = playerCountryInfo(opponentPartnerRow);

    // player
    const playerFirstName = playerRow
      ? playerRow.PlayerFirstName.charAt(0)
      : "";
    const playerLastName = playerRow ? playerRow.PlayerLastName : "";

    // partner
    const partnerFirstName = partnerRow
      ? partnerRow.PlayerFirstName.charAt(0)
      : "";
    const partnerLastName = partnerRow ? partnerRow.PlayerLastName : "";

    // opponent
    const opponentPlayerFirstName = oponentRow
      ? opponentRow.PlayerFirstName.charAt(0)
      : "";
    const opponentPlayerLastName = oponentRow ? opponentRow.PlayerLastName : "";

    // opponent partner
    const opponentPartnerFirstName = opponentPartnerRow
      ? opponentPartnerRow.PlayerFirstName.charAt(0)
      : "";
    const opponentPartnerLastName = opponentPartnerRow
      ? opponentPartnerRow.PlayerLastName
      : "";

    rowInformation = '<div class="container live-tennis">';

    const playerFirstAndLastName = playerRowHTML(
      playerCountry,
      `${playerFirstName}. ${playerLastName}`
    );

    if (!partnerLastName) {
      rowInformation += `
        <div class="row row-first">
          ${playerFirstAndLastName}
          ${playerScoring(livePLayerTeamGameScore, livePLayerTeamSetScores)}
        </div>`;
    }

    if (partnerLastName) {
      rowInformation += `
        <div class="row row-first">
          <div class="d-flex p-0">
            <div class="flex-fill">
              ${playerFirstAndLastName}
              ${playerRowHTML(
                partnerCountry,
                `${partnerFirstName}. ${partnerLastName}`
              )}
            </div>
            ${playerScoring(livePLayerTeamGameScore, livePLayerTeamSetScores)}
          </div>
        </div>`;
    }

    const opponentFirstAndLastName = playerRowHTML(
      opponentCountry,
      `${opponentPlayerFirstName}. ${opponentPlayerLastName}`
    );

    if (!opponentPartnerLastName) {
      rowInformation += `
        <div class="row row-second">
          ${opponentFirstAndLastName}
          ${playerScoring(liveOpponentTeamGameScore, liveOpponentTeamSetScores)}
        </div>`;
    }

    if (opponentPartnerLastName) {
      rowInformation += `
        <div class="row row-second">
          <div class="d-flex p-0">
            <div class="flex-fill">
              ${opponentFirstAndLastName}

              ${playerRowHTML(
                opponentParnerCountry,
                `${opponentPartnerFirstName}. ${opponentPartnerLastName}`
              )}

            </div>

            ${playerScoring(
              liveOpponentTeamGameScore,
              liveOpponentTeamSetScores
            )}
        </div>
      </div>`;
    }

    rowInformation += "</div>";
    checkLive = true;
  }

  let htmlRoundName = "";
  if (item.RoundShortName && item.type === "LIVEDATA") {
    htmlRoundName = `, ${item.RoundShortName}`;
  }

  // display time
  let displayTime = item.type === "LIVEDATA" ? item.DisplayTime : "";

  // let centerText = item.type === "LIVEDATA" ? " text-center" : "";
  let centerText = " text-center";

  let results = getDailySchedule(item.ResultString);

  let timeAndRundName =
    displayTime || htmlRoundName
      ? `<div class="text-center fw-bold p-1">${displayTime}${htmlRoundName}</div>`
      : "";

  results = results
    ? `<div class="tennis-results p-1 py-0 ${centerText}">${results}</div>`
    : "";

  // show starting day if item type is not livedata and results is null
  const showStaringDay =
    item.type !== "LIVEDATA" && !results
      ? `<div class="text-center fw-bold p-1">${item.DisplayTime}</div>`
      : "";

  let html = `
    
    <div class="tennis-players row p-1 px-3">
      ${showStaringDay}
      ${timeAndRundName}
      ${rowInformation}
      ${results}
    </div>`;

  html += "</div>";

  return html;
}

/**
 * Get daily schedule
 *
 * @param {string} resultString
 * @returns string
 */
function getDailySchedule(resultString) {
  if (!resultString) return;

  // replace ( and ) with <sup> and </sup>
  const supText = resultString.replace(/(\(|\))/g, (m) =>
    m === "(" ? "<sup>(" : ")</sup>"
  );

  return supText;
}

/**
 * Player html row with flag
 */
function playerRowHTML(countryName, playerName) {
  countryName = countryName.toLowerCase();

  const playerRow = `
    <div class="col p-1 px-0 text-center align-middle">
      <div class="d-flex gap-1 align-items-center">
        <div title="${countryName}" class="player-first flag-icon flag-icon-${countryName}"></div>
        <div class="player-name text-start">${playerName}</div>
      </div>
    </div>`;

  return playerRow;
}

/**
 * Player scoring
 */
function playerScoring(gameScore, scores) {
  const classLiveScore =
    "col-1 p-1 live-score center-data text-nowrap border-right text-center";

  let scoringRow = gameScore
    ? `
    <div data-score="${gameScore}" class="${classLiveScore}">${gameScore}</div>`
    : "";

  scores
    .map((score, index) => {
      if (index === 0) return;
      scoringRow += `
        <div class="${classLiveScore}">
          ${score.SetScore}
        </div>`;
    })
    .join("");

  return scoringRow;
}

/**
 * Flag element
 */
function flagWithName(playerName, countryName) {
  if (!countryName) return;

  countryName = countryName.toLowerCase();

  const flagRow = `
    <div class="d-flex align-items-center gap-2 mb-1">
      <div title="${countryName}" class="player-first mr-2 flag-icon flag-icon-${countryName}"></div>
      ${playerName}
      </div>
    </div>`;

  return flagRow;
}

/**
 * Player name row
 * @param {obj} player
 */
function rowPlayerName(player) {
  const playerFirstName = player.PlayerFirstName.charAt(0);
  const playerLastName = player.PlayerLastName;

  return `
    <div class="player-name">
      ${playerFirstName}. ${playerLastName}
    </div>`;
}

// get player country info
function playerCountryInfo(player) {
  return player.PlayerCountry ? player.PlayerCountry : "";
}
